export default __webpack_public_path__ + "static/media/Untitled-1.edd4b5de.jpg";